import React, { FC } from 'react';
import { useFormState } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import Joi from 'joi';
import { ErrorSummary } from '@digdir/designsystemet-react';

import { State } from './utils';
import { reduceErrors, SUM_OPPVARMING_ERROR, SUM_TAPPEVANN_ERROR } from './validation';

export const ErrorMessage: FC = () => {
  const { t } = useTranslation();
  const { errors } = useFormState<State>();

  if (Object.keys(errors).length === 0) {
    return null;
  }

  const reducedErrors = reduceErrors(
    // Need to to a cast here because react-hook-form cant infer correct error types
    // when used with a custom joi resolver.
    errors as Record<string, Joi.ValidationErrorItem>
  );

  return (
    <ErrorSummary>
      <ErrorSummary.Heading>{t('register.errorMessage.description')}</ErrorSummary.Heading>
      <ErrorSummary.List aria-label={t('register.errorMessage.list')}>
        {Object.entries(reducedErrors).map(([field, error]) => {
          if (field === SUM_OPPVARMING_ERROR || field === SUM_TAPPEVANN_ERROR) {
            const customErrorMessageLabel = t(`register.parameters.error.${field}`, { limit: error?.limit });

            // Custom errors need interpolation, so render a Trans inside the item.
            return (
              <ErrorSummary.Item key={field} aria-label={customErrorMessageLabel}>
                <Trans
                  i18nKey={`register.parameters.error.${field}`}
                  values={{ limit: error?.limit }}
                  components={[<i key={0} />]}
                />
              </ErrorSummary.Item>
            );
          }

          const translatedField = t(`register.parameters.type.${field}`);
          const errorMessage = t(`register.parameters.error.${error.type}`, {
            field: translatedField,
            limit: error.limit
          });

          return (
            <ErrorSummary.Item key={field} aria-label={errorMessage}>
              {errorMessage}
            </ErrorSummary.Item>
          );
        })}
      </ErrorSummary.List>
    </ErrorSummary>
  );
};
